import { mergePatch } from "./utils/index.js";
export function interpretConfigurationModelSimple(configuration, key, initialValue = {}) {
    const rawData = configuration.getRawData()[key] ?? {};
    return mergePatch(initialValue, rawData);
}
export function applyConfigurationModelSimple(configuration, key, data) {
    const rawData = configuration.getRawData();
    configuration.setRawData({
        ...rawData,
        [key]: data
    });
}
//# sourceMappingURL=simple-configurator.js.map